const clone = (obj) => {
    return Object.create(obj);
};
export default clone;
